import {
  ArrowLeft,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  Download,
  Eye,
  Filter,
  Globe,
  Grid2x2,
  Image as ImageIcon,
  Info,
  LayoutDashboard,
  LogOut,
  Menu,
  Pencil,
  Plus,
  QrCode,
  Search,
  Send,
  Settings,
  Shield,
  Sparkles,
  Store,
  Trash2,
  TriangleAlert,
  Upload,
  Users,
  UtensilsCrossed,
  X,
  type LucideProps,
} from 'lucide-react';

export const ICONS = {
  'arrow-left': ArrowLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'chevron-down': ChevronDown,
  dashboard: LayoutDashboard,
  utensils: UtensilsCrossed,
  settings: Settings,
  logout: LogOut,
  globe: Globe,
  grid: Grid2x2,
  search: Search,
  image: ImageIcon,
  info: Info,
  warn: TriangleAlert,
  danger: CircleAlert,
  sparkle: Sparkles,
  check: Check,
  close: X,
  qr: QrCode,
  store: Store,
  menu: Menu,
  send: Send,
  download: Download,
  upload: Upload,
  trash: Trash2,
  plus: Plus,
  filter: Filter,
  users: Users,
  shield: Shield,
  pencil: Pencil,
  eye: Eye,
} as const;

export type IconName = keyof typeof ICONS;

export interface IconProps extends Omit<LucideProps, 'name'> {
  name: IconName;
  title?: string;
}

export function Icon({ name, size = 18, title, ...rest }: IconProps) {
  const Component = ICONS[name];

  if (!title) {
    return <Component size={size} strokeWidth={2} aria-hidden="true" {...rest} />;
  }

  return (
    <Component size={size} strokeWidth={2} role="img" aria-label={title} {...rest}>
      <title>{title}</title>
    </Component>
  );
}
